import { lazy } from 'react';
import { pathFactory } from '@hwm/ui-lib/core/routes';

const PressView = lazy(() => import('@features/PressView'));
const ControlView = lazy(() => import('@features/ControlView'));
const GraphsView = lazy(() => import('@features/GraphsView'));
const LogsView = lazy(() => import('@features/LogsView'));
const AlarmsView = lazy(() => import('@features/AlarmsView'));
const CookieSettings = lazy(() => import('@features/CookieSettings/CookieSettings'));

export const AppPaths = {
  controlView: pathFactory(
    {
      base: '/control',
    },
    ControlView,
    true
  ),
  cookieSettings: pathFactory(
    {
      base: '/cookie-settings',
    },
    CookieSettings,
    true
  ),
  graphsView: pathFactory(
    {
      base: '/graphs',
    },
    GraphsView,
    true
  ),
  logsView: pathFactory(
    {
      base: '/logs',
    },
    LogsView,
    true
  ),
  alarmsView: pathFactory(
    {
      base: '/alarms',
    },
    AlarmsView,
    true
  ),
  pressView: pathFactory(
    {
      base: '/',
    },
    PressView,
    true
  ),
};
